import { useEffect, useState } from 'react';
import { getHoldingReturns } from '../api/endpointsBackend';

/**
 * Every holding's and broker's return in `currency`, by account id: since
 * purchase, or from `start` (ISO day) to today. Null while there is no
 * currency to ask for, while loading, and on error, so a caller falls back
 * to the holding's own-currency figures.
 *
 * `version` refetches when it changes identity: the accounts the panel or
 * the page holds, which change after a price or a trade is saved.
 *
 * docs/specs/2026-10-24-holding-returns-in-display-currency-design.md §2.
 */
export default function useHoldingReturns(currency, start = null, version = null) {
  const [returns, setReturns] = useState(null);
  useEffect(() => {
    setReturns(null);
    if (!currency) return undefined;
    let active = true;
    getHoldingReturns(currency, start)
      .then((data) => {
        if (!active) return;
        setReturns({
          currency: data.currency,
          start: data.start,
          holdings: new Map((data.holdings || []).map((r) => [r.account_id, r])),
          brokers: new Map((data.brokers || []).map((r) => [r.account_id, r])),
        });
      })
      .catch((err) => {
        console.error('Failed to fetch holding returns:', err);
      });
    return () => { active = false; };
  }, [currency, start, version]);
  return returns;
}
